// react imports
import PropTypes from 'prop-types';

// project imports
import fileMngrFormatIcons from '../utils/fileMngrFormatIcons';

// material-ui icons import
import { Folder as FolderIcon } from '@mui/icons-material';

// ==============================|| FILEMNGR ICON COMPONENT ||============================== //

/**
 * FileMngrIconComponent component
 * @author Marcos L. A. Soto <marcosleonildo@gmail.com>
 * @param {boolean} isFile
 * @param {number} iconSize
 * @param {string} format
 * @returns {Icon} component
 */
const FileMngrIconComponent = ({ isFile, iconSize, format }) =>
    isFile ? (
        <img width={iconSize} alt={format ?? 'unknown-file'} src={fileMngrFormatIcons[format] ?? fileMngrFormatIcons.unknownFormat} />
    ) : (
        <FolderIcon sx={{ fontSize: iconSize }} />
    );

FileMngrIconComponent.propTypes = {
    isFile: PropTypes.bool,
    iconSize: PropTypes.number,
    format: PropTypes.string
};

export default FileMngrIconComponent;
